export const PER_PAGE_ALL = 100
export const DEFAULT_PER_PAGE = 10
export const ACCESS_TOKEN_KEY = '__access_token__'
